import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  FormControlLabel,
  Switch,
  Grid,
  IconButton,
} from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import ButtonCustom from '../../../../components/ButtonCustom';
import { Close as CloseIcon } from '@mui/icons-material';
interface ExportDialogProps {
  open: boolean;
  onClose: () => void;
  columns: GridColDef[];
}

const ExportDialog: React.FC<ExportDialogProps> = ({
  open,
  onClose,
  columns,
}) => {
    const [selectedFields, setSelectedFields] = useState<string[]>(
        columns.filter((col) => col.headerName !== 'Opções').map((col) => col.field)
      );

  const handleToggleField = (field: string) => {
    if (field === 'Opções') {
        return;
    }
    setSelectedFields((prevFields) =>
      prevFields.includes(field)
        ? prevFields.filter((f) => f !== field)
        : [...prevFields, field]
    );
  };

  useEffect(() => {
    // Retrieve the value from localStorage when the modal is accessed
    const storedFieldsString = localStorage.getItem('selectedFields');
    const storedFieldsArray = storedFieldsString ? storedFieldsString.split(',') : [];
    // Set the retrieved values to the state
      setSelectedFields(storedFieldsArray);
  }, [open]);
  
  const handleSave = () => {
  localStorage.setItem('selectedFields', selectedFields.join(','));
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
      <IconButton
          edge="end"
          color="inherit"
          onClick={onClose}
          aria-label="close"
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
        Selecione os Campos para Exportar</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          {columns.map((col) => (
            col.headerName !== 'Opções' &&
(            <Grid item xs={12} sm={12} key={col.field}>
              <FormControlLabel
                control={
                  <Switch
                    checked={selectedFields.includes(col.field)}
                    onChange={() => handleToggleField(col.field)}
                    color="primary"
                  />
                }
                label={col.headerName}
              />
            </Grid>
)
          ))}
        </Grid>
        <ButtonCustom text='Salvar' event={handleSave}/>
      </DialogContent>
    </Dialog>
  );
};

export default ExportDialog;
